module.exports = __webpack_public_path__ + "assets/img/Back_003.db489f2c-ps.jpg";